'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var audioPlayer = function audioPlayer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case 'AUDIO_PLAY_FILE':
      return _extends({}, state, {
        file: action.file
      });
    case 'AUDIO_PAUSE':
      return _extends({}, state, {
        paused: !state.paused
      });
    default:
      return state;
  }
};

exports.default = audioPlayer;


//////////////////
// WEBPACK FOOTER
// ./client/reducers/audioPlayer.js
// module id = 114
// module chunks = 0